import { z } from 'zod';

export const declarationGeneralSchema = z.object({
  messageInfo: z.object({
    declarationMainType: z.string().optional(),
    declarationType: z.string().optional(),
    acceptanceDate: z.string().nullable().optional(),
    security: z.number().optional(),
  }),
  generalInfo: z.object({
    group: z.string().optional(),
  }),
  consignment: z.object({
    carrier: z.string().optional(),
    carrierHeader: z.boolean().optional(),
    referenceNumberUCR: z.string().optional(),
    referenceNumberUCRHeader: z.boolean().optional(),
    customsOfficePresentation: z.object({
      issuingPlaceCode: z.string().optional(),
      referenceNumber: z.string().optional(),
    }),
    customsSupervisingOffice: z.object({
      referenceNumber: z.string().optional(),
    }),
    customsOfficeExport: z.object({
      referenceNumber: z.string().optional(),
    }),
    locationOfGoods: z.object({
      unLocode: z.string().optional(),
    }),
    countryOfDispatch: z.string().optional(),
    countryOfDispatchHeader: z.boolean().optional(),
    destinationHeader: z.boolean().optional(),
    countryOfDestination: z.string().optional(),
    regionOfDestination: z.string().optional(),
    countryOfExportHeader: z.boolean().optional(),
    countryOfExport: z.string().optional(),
    customsOfficeExit: z.object({
      referenceNumber: z.string().optional(),
    }),
  }),
  otherDataElements: z.object({
    registrationNumber: z.string().optional(),
    natureOfTransaction: z.string().optional(),
    natureOfTransactionHeader: z.boolean().optional(),
  }),
  goodShipmentGlobal: z.object({
    procedureHeader: z.boolean().optional(),
    customsProcedureType: z.string().optional(),
    customsNationalProcedure: z.string().optional(),
    customsProcedure: z.string().optional(),
    customsNationalProcedureCode: z.string().optional(),
    preference: z.string().optional(),
  }),
  valuationInformationTaxes: z.object({
    deliveryTerms: z.object({
      incotermCode: z.string().optional(),
      location: z.string().optional(),
      country: z.string().optional(),
    }),
  }),
  transportInformation: z.object({
    inlandModeOfTransport: z.string().optional(),
    modeOfTransportMeansAtTheBorder: z.string().optional(),
    arrivalTransportMeans: z.object({
      typeOfIdentification: z.number().optional(),
      identificationNumber: z.string().optional(),
    }),
    departureTransportMeans: z.object({
      typeOfIdentification: z.string().optional(),
      identificationNumber: z.string().optional(),
      nationality: z.string().optional(),
    }),
    activeBorderTransportMeans: z.object({
      nationality: z.string().optional(),
      typeOfIdentification: z.string().optional(),
      identificationNumber: z.string().optional(),
    }),
    transportEquipment: z.object({
      header: z.boolean().optional(),
      containerIdentification: z.string().optional(),
      containers: z
        .array(
          z.object({
            identificationNumber: z.string().optional(),
            seals: z.array(
              z.object({
                identificationNumber: z.string().optional(),
              }),
            ),
          }),
        )
        .optional(),
    }),
    countryOfRoutingOfConsignment: z.array(
      z.object({
        country: z.string().optional(),
      }),
    ),
  }),
  declarationGoods: z.object({
    additionalProcedure: z.array(z.string()).optional(),
    packaging: z.object({
      typeOfPackages: z.string().optional(),
    }),
  }),
});

export type DeclarationGeneralFormValues = z.infer<typeof declarationGeneralSchema>;
